import { HTTPClient } from "@abaco/web-common/src/HTTP";
import { ServerInfo, ServerUPass, UserOut, AccreditationStatus, ColdirettiDemoUser } from "./models/Register";

export default class RegisterResource {

    private http: HTTPClient;

    constructor() {
        this.http = new HTTPClient();
    }

    public async addBasicAuthConfig() {
        const serverInfo = await this.getTime();
        const upass = await this.getUpass(serverInfo);
        this.http.addRequestConfigProvider(async (config) => {
            config.auth = {
                username: upass.user,
                password: upass.upass
            }
        })
    }

    private async getUpass(serverInfo: ServerInfo): Promise<ServerUPass> {
        const url = "/siticatasto/siti.actionsNoSSO"
        const params = {
            action: "agriPortal",
            subAction: "getAuthenticationUpass",
            utime: serverInfo.utime,
            server_id: serverInfo.server_id
        }

        return (await this.http.get(url, { params })).data.argument;
    }

    private async getTime(): Promise<ServerInfo> {
        const url = "/siticatasto/dbgis-servlet/time";
        const params = {
            sekill: 1
        }
        const res = await this.http.get(url, { params });
        return res.data;
    }

    public async existsSsoUser(username: string): Promise<boolean> {

        const url = "/siticatasto/dbgis-servlet/tl_data"
        const params = {
            svccode: "gurl_services/exists_sso_user",
            userid: username
        }

        const res = await this.http.get(url, { params })
        return res.data.services[0].entities[0].retcount > 0;
    }

    public async existsGuAccreditamento(username: string): Promise<boolean> {

        const url = "/siticatasto/dbgis-servlet/tl_data"
        const params = {
            svccode: "gurl_services/exists_gu_accreditamento",
            userid: username
        }

        const res = await this.http.get(url, { params })
        return res.data.services[0].entities[0].retcount > 0;
    }

    public async isPasswordOk(password: string): Promise<number> {

        const url = "/siticatasto/dbgis-servlet/tl_data"
        const params = {
            svccode: "gurl_services/is_password_ok",
            password: password
        }

        const res = await this.http.get(url, { params })
        return res.data.services[0].entities[0].ok;
    }

    public async getPkcuaaFromCuaa(cuaa: string): Promise<number> {

        const url = "/siticatasto/dbgis-servlet/tl_data"
        const params = {
            svccode: "portal/get_pkcuaa_from_cuaa",
            cuaa: cuaa
        }

        const res = await this.http.get(url, { params })
        return res.data.services[0].entities[0].pkcuaa;
    }

    public async isCuaaValid(cuaa: string, lang: string): Promise<boolean> {
        const url = "/siticatasto/dbgis-servlet/tl_data";
        const params = {
            cuaa: cuaa,
            lang: lang,
            svccode: "portal/check_cuaa"
        }

        const res = await this.http.get(url, { params });
        return res.data.services[0].entities[0].error_count == 1;
    }

    public async submitAccrRequest(user: UserOut): Promise<string> {
        const url = "/register-api/api/v1/register/submit";
        const res = await this.http.post(url, user);
        return res.data;
    }

    public async registerAccrSuccess(request_id: string): Promise<AccreditationStatus> {
        const url = `/register-api/api/v1/register/${request_id}/accreditation`;

        const res = await this.http.put(url);
        return res.data.status;
    }

    public async verifyAccreditation(request_id: string): Promise<AccreditationStatus> {
        const url = `/register-api/api/v1/register/${request_id}/verify-accreditation`;

        const res = await this.http.get(url);
        return res.data.status;
    }

    public async coldirettiDemoRegisterUser(user: ColdirettiDemoUser): Promise<string> {
        const url = `/register-api/api/v1/register/demo/submit`;

        const res = await this.http.post(url, user);
        return res.data.status;
    }

    public async askForPasswordReset(userid: string, environment: string) {
        const url = `/siticatasto/dbgis-servlet/tl_data`;
        const params = {
            svccode: "gurl_services/ask_for_password_reset",
            userid: userid,
            appcode: environment + "_V2"
        }
        const res = await this.http.get(url, { params })
        return res.data;
    }

    public async acceptPasswordReset(reqToken: string, environment: string): Promise<number> {
        const url = `/siticatasto/dbgis-servlet/tl_data`;
        const params =
        {
            svccode: "gurl_services/accept_password_reset",
            request_token: reqToken,
            appcode: environment
        }
        const res = await this.http.get(url, {params});
        return res.data.services[0].entities[0].retval;
    }
}
